export enum LocaleEnum {
  LOCALE_HR = 'hr',
  LOCALE_SI = 'sl',
  LOCALE_EN = 'en',
  LOCALE_DE = 'de',
  LOCALE_FR = 'fr',
  LOCALE_PL = 'pl',
}
